const miiaFwStore = {
  namespaced: true,
  state: {
    loadingView: { isLoading: false, message: '' },
    loadingImage: null,
    cognitoAuth: { isAuthorized: false, menu: [], attributes: undefined, sensitiveInfo: undefined, refreshState: undefined }
  },
  getters: {
    isLoading (state) { return state.loadingView.isLoading },
    loadingMessage (state) { return state.loadingView.message },
    loadingImage (state) { return state.loadingImage },
    isAuthorized (state) { return state.cognitoAuth.isAuthorized },
    menu (state) { return state.cognitoAuth.menu },
    attributes (state) { return state.cognitoAuth.attributes },
    sensitiveInfo (state) { return state.cognitoAuth.sensitiveInfo },
    refreshState (state) { return state.cognitoAuth.refreshState }
  },
  mutations: {
    enableLoadingView (state, argMessage) {
      state.loadingView = { isLoading: true, message: argMessage }
    },
    disableLoadingView (state) {
      const currentMessage = state.loadingView.message
      state.loadingView = { isLoading: false, message: currentMessage }
    },
    updateLoadingImage (state, imageData) {
      state.loadingImage = imageData
    },
    updateIsAuthorized (state, isAuthorized) {
      state.cognitoAuth.isAuthorized = isAuthorized
    },
    updateMenu (state, menu) {
      if (Array.isArray(menu)) {
        state.cognitoAuth.menu = menu
      } else {
        // console.error('不正な型が指定されたため、メニュー表示項目の更新に失敗しました。')
      }
    },
    updateAttributes (state, attributes) {
      state.cognitoAuth.attributes = attributes
    },
    updateSensitiveInfo (state, obj) {
      state.cognitoAuth.sensitiveInfo = obj
    },
    updateRefreshState (state, obj) {
      state.cognitoAuth.refreshState = obj
    }
  }
}

export default miiaFwStore
